import type { FormSchema } from '@atlas/react-forms';
import createRequest from '../utils/request.ts';

export enum ResetPasswordTypes {
  PHONE = 'PHONE',
  EMAIL = 'EMAIL',
}

type ActiveFormsRequestParams = {
  query: {
    formType: string;
  };
};

export type ChangePasswordRequestError = {
  status: number;
  code: string;
  message: string;
  traceId: string;
  timestamp: number;
};

export const activeFormsRequest = createRequest<
  FormSchema[],
  ActiveFormsRequestParams
>('/api/client/form:get-active-forms');

export type LoginResponse = {
  sessionToken: string;
  userRole: string[];
  is2FaEnabled: boolean;
};

type LoginRequest = {
  body: {
    id: number;
    values: Record<string, unknown>;
  };
};

export const loginRequest = createRequest<LoginResponse, LoginRequest>(
  '/api/client/clients:login-with-form',
  {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
  },
);

type RegisterResponse = {
  clientId: number;
  login: string;
  password: string;
  showPopup: boolean;
  testAccount: boolean;
  postAction: string;
};

type RegisterRequest = {
  body: {
    id: number;
    values: Record<string, unknown>;
  };
};

export const registerRequest = createRequest<RegisterResponse, RegisterRequest>(
  '/api/client/clients:register-with-form',
  {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
  },
);

// async validation
export type ErrorViolation = {
  code: string;
  type: string;
  message: string;
};

type AsyncError = {
  fieldName: string;
  violations: ErrorViolation[];
};

export type AsyncValidationResponse = {
  code: string;
  errors: AsyncError[];
  message: string;
  status: number;
};

type AsyncValidationRequest = {
  body: {
    fieldName: string;
    formId: string;
    value: string;
  };
};

export const asyncValidationRequest = createRequest<
  AsyncValidationResponse,
  AsyncValidationRequest
>('/api/client/form:validate-field', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
  },
});

type AuthorizationRequest = {
  body: Record<string, unknown>;
};

export const authorizationRequest = createRequest<
  LoginResponse,
  AuthorizationRequest
>('/api/auth/login', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
  },
});

export type InitResetPasswordResponse = {
  publicToken: string;
  resetType: ResetPasswordTypes;
  success: boolean;
};

type InitResetPasswordRequest = {
  body: {
    id: number;
    values: Record<string, unknown>;
  };
};

export const initResetPasswordRequest = createRequest<
  InitResetPasswordResponse,
  InitResetPasswordRequest
>('/api/client/clients:initPasswordReset-with-form', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
  },
});

export type ResetPasswordResponse = {
  success: boolean;
};

type ResetPasswordRequest = {
  body: {
    id: number;
    resetToken: string;
    values: Record<string, unknown>;
  };
};

export const resetPasswordRequest = createRequest<
  ResetPasswordResponse,
  ResetPasswordRequest
>('/api/client/clients:passwordReset-with-form', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
  },
});

type ChangePasswordRequest = {
  body: {
    id: number;
    values: Record<string, unknown>;
  };
};

export const changePasswordRequest = createRequest<
  string,
  ChangePasswordRequest
>('/api/client/clients:changePassword-with-form', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
  },
});
